import { Misc } from "./Misc";

export class OrderHelper {
    public static padDailyIncrement(incr: number): string {
        return Misc.padDigits(incr, 3);
    }
}
